export const ROLES = {
  ROLE_VOUCHER_PORTAL_ADMIN: 'ROLE_VOUCHER_PORTAL_ADMIN', //admin role
  ROLE_VIEW_VOUCHER_LIST: 'ROLE_VIEW_VOUCHER_LIST',
  ROLE_VIEW_VOUCHER_DETAIL: 'ROLE_VIEW_VOUCHER_DETAIL',
  ROLE_UPDATE_MULTIPLE_VOUCHERS: 'ROLE_UPDATE_MULTIPLE_VOUCHERS',
  ROLE_REACTIVATE_VOUCHER: 'ROLE_REACTIVATE_VOUCHER',
  ROLE_MANAGE_GOODWILL_VOUCHER: 'ROLE_MANAGE_GOODWILL_VOUCHER',
  ROLE_MANAGE_ACCOMPANYING_PERSON_VOUCHER: 'ROLE_MANAGE_ACCOMPANYING_PERSON_VOUCHER',
  ROLE_MANAGE_MARKETING_VOUCHER: 'ROLE_MANAGE_MARKETING_VOUCHER',
  ROLE_MANAGE_AGTPEP_VOUCHER: 'ROLE_MANAGE_AGTPEP_VOUCHER',
  ROLE_CREATE_MULTI_MARKETING_VOUCHER: 'ROLE_CREATE_MULTI_MARKETING_VOUCHER',
};
